// src/api/secureApi.js

import { HEADERS } from "../constants/headers";
import axios from "axios";
import { API_URL } from "../utils/apiUtils";

const AUTH_URL = `${API_URL}/auth`;

const secureApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: HEADERS,
});

// 公開ページ（未ログインで表示できるページ）。
// App.js の Public routes と同期が必要。追加漏れがあるとそのページでリフレッシュ失敗時に /login へ飛ぶ。
const PUBLIC_PATHS = [
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/mail-confirmation",
];
const PUBLIC_PATH_PREFIXES = ["/blog/", "/preview/"];

export const isPublicPath = (pathname) => {
  if (typeof pathname !== "string") return false;
  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;
  if (PUBLIC_PATHS.includes(normalized)) return true;
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

export const refreshAuthToken = async (originalRequest) => {
  try {
    await secureApi.post(`${AUTH_URL}/refresh`);
    originalRequest._retry = true;
    return secureApi(originalRequest);
  } catch (refreshError) {
    // Issue #160: 公開ページ（特に /login）でリダイレクトするとフルリロードのループになるため飛ばさない
    if (!isPublicPath(window.location.pathname)) {
      window.location.href = "/login";
    }
    return Promise.reject(refreshError);
  }
};

export const handleUnauthorizedError = async (error) => {
  const originalRequest = error.config;
  if (
    error.response &&
    error.response.status === 401 &&
    !originalRequest._retry
  ) {
    return refreshAuthToken(originalRequest);
  }
  return Promise.reject(error);
};

secureApi.interceptors.response.use(
  (response) => response,
  (error) => handleUnauthorizedError(error),
);

export default secureApi;
